import { isGoGameEnv } from 'App/constants';

const SHARED_ID = 2;
const CUSTOM_ID = 1;

export const formatData = (data) => {
  const results = [];
  // let hasCustomGroup = false;
  for (let i = 0; i < data.length; i++) {
    const shouldSkipShared = !isGoGameEnv && data[i].categoryId === SHARED_ID;
    if (shouldSkipShared) {
      continue;
    }
    // if (!hasCustomGroup && data[i].categoryId === CUSTOM_ID) {
    //   hasCustomGroup = true;
    // }
    const { groupName, groupId, ...metric } = data[i];
    const found = results.find((el) => el.name === groupName);
    if (found) {
      found.children.push({ groupName, groupId, ...metric });
    } else {
      const group = {
        name: groupName,
        id: groupId,
        children: [{ groupName, groupId, ...metric }],
      };
      results.push(group);
    }
  }
  // if (!hasCustomGroup && ensureCustomMetricsGroup) {
  //   results.push({ name: 'My Custom Metrics', id: 14, children: [] });
  // }
  return results;
};

export const formatDataWithCustomMetricsGroup = (data) => {
  const [...results] = formatData(data);

  if (
    !results.some((g) =>
      g.children.some((metric) => metric.categoryId === CUSTOM_ID)
    )
  ) {
    results.push({ name: 'My Custom Metrics', id: 14, children: [] });
  }

  return results;
};
